/**
 * @desc 列表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.finalTrialOrder.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/wms/finalTrialOrder/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
